/* eslint-disable */
import React from 'react'
import { ReactComponent as MENU } from '@/assets/svg/menu.svg'

import { ReactComponent as TIPSSVG } from '@/assets/svg/tips.svg'
import toast from 'react-hot-toast'
import { Link, useNavigate } from 'react-router-dom'

import { useTranslation } from 'react-i18next'
import ConnectModale from '@/components/Connect'
import { useWeb3ModalAccount } from '@web3modal/ethers/react'

import { ReactComponent as TELEGRAM } from '@/assets/svg/telegram.svg'
import { ReactComponent as MORE } from '@/assets/svg/more.svg'
import { ReactComponent as TWITTER } from '@/assets/svg/twitter.svg'
import { Modal, ModalBody, ModalContent, ModalHeader, useDisclosure } from '@nextui-org/react'

import BG_RIGHT from '@/assets/menu-bg-right.png'
import { ReactComponent as LOGO } from '@/assets/logo.svg'
import { ReactComponent as CLOSE } from '@/assets/icon/close.svg'
import LangModule from '../Lang'
import Footer from '../Footer'

const List: {
	label: string
	uri: string
	target?: '_blank'
}[] = [
	{ label: 'menu.home', uri: '/home' },
	{ label: 'menu.my.orders', uri: '/orders' },
	{ label: 'menu.stake', uri: '/stake' },
	{ label: 'menu.token', uri: '' },
	{ label: 'menu.about', uri: '/about' },
	{ label: 'menu.about.faq', uri: '/help' },
	{ label: 'menu.serve', uri: '/serve' },
	{ label: 'menu.privacy', uri: '/privacy' },
]

export default function MenuModule() {
	const { t } = useTranslation()
	const { isConnected } = useWeb3ModalAccount()

	const { isOpen, onOpen, onOpenChange } = useDisclosure()

	const navigate = useNavigate()

	return (
		<div className="">
			<MENU
				className="cursor-pointer"
				onClick={() => {
					onOpen()
				}}
			/>
			<Modal
				classNames={{
					base: 'tail-menu-modal',
				}}
				placement="top"
				isOpen={isOpen}
				hideCloseButton={true}
				size="full"
				scrollBehavior="inside"
				onOpenChange={onOpenChange}
			>
				<ModalContent>
					{onClose => (
						<>
							<ModalHeader className="flex items-center justify-between">
								<Link to="/" onClick={onClose}>
									<LOGO />
								</Link>
								<div className="flex items-center justify-between gap-3">
									<LangModule />
									<CLOSE className="shrink-0 cursor-pointer" onClick={() => onClose()} />
								</div>
							</ModalHeader>
							<ModalBody>
								<img src={BG_RIGHT} alt="" className="absolute z-0 bottom-[9.375rem] right-0 h-[24.375rem]" />
								<div className="relative z-10 py-5">
									<div className="flex flex-col items-start gap-10">
										{List.filter(item => {
											if (!isConnected) return item.uri !== '/orders'
											return true
										}).map((item, key) => (
											<div
												onClick={() => {
													if (item.uri === '') {
														toast('Coming Soon', {
															icon: <TIPSSVG className="h-4 w-4" />,
														})
													} else if (item.target) {
														window.open(item.uri)
													} else {
														navigate(item.uri, {
															replace: true,
														})
														onClose()
													}
												}}
												className="group w-auto cursor-pointer"
												key={key}
											>
												<span className="line-clamp-1 w-full text-2xl uppercase group-hover:text-[var(--theme)]">
													{t(item.label)}
												</span>
											</div>
										))}
										<ConnectModale />
									</div>
									<Footer baseClassName="pb-5 pt-20" />
									<div className="mb-5 flex !h-[3.125rem] shrink-0 items-center justify-center gap-8 rounded-full border border-white/[0.13] bg-white/[0.03] px-4 backdrop-blur-sm">
										<span className="line-clamp-1 text-base font-normal text-white">Stay tuned for more services</span>
										<div className="flex h-[1.625rem] items-center gap-3">
											<a
												target="_blank"
												href="https://t.me/FCMofficeUS"
												rel="noreferrer"
												onClick={() => {
													onClose()
												}}
											>
												<TELEGRAM className="h-auto cursor-pointer" />
											</a>
											<a
												target="_blank"
												href="https://x.com/fcmoffice"
												rel="noreferrer"
												onClick={() => {
													onClose()
												}}
											>
												<TWITTER className="cursor-pointer" />
											</a>
										</div>
									</div>
								</div>
							</ModalBody>
						</>
					)}
				</ModalContent>
			</Modal>
		</div>
	)
}
